import { useLocation } from 'react-router-dom';
import {
  getLibrarySearch,
  getVideoDetailsPath,
} from '../common/utils/video-route-utils';

export function useVideoDetailsPath(): (videoId: string) => string {
  const { pathname, search } = useLocation();
  const librarySearch = getLibrarySearch(pathname, search);

  return (videoId) => getVideoDetailsPath(videoId, librarySearch);
}
